/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'message': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" _fill="#01B9CA" d="M10 2a8 8 0 016.874 12.096l1.099 3.233a.508.508 0 01-.614.653l-3.456-.944C12.755 17.682 11.446 18 10 18a8 8 0 110-16zm0 1.015a6.985 6.985 0 100 13.971c1.348 0 2.54-.308 3.57-.928a.502.502 0 01.395-.055l2.74.749-.869-2.556a.512.512 0 01.061-.448A6.958 6.958 0 0016.985 10a6.985 6.985 0 00-6.986-6.985zm0 8.619a.507.507 0 010 1.014H7.86a.507.507 0 11-.001-1.014H10zm2.14-3.212a.509.509 0 01.001 1.015H7.86a.507.507 0 11-.001-1.015h4.282z" fill-rule="evenodd"/>'
  }
})
